export const DESKTOP_MIN_LAYOUT_SIZE = 991 as const;
